<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Real Estate Agents</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Take your real estate business to new heights with LocalScale, your partner in targeted advertising for the dynamic housing market</p>
                        <p>In the competitive world of real estate, standing out from the competition is key to success, especially in rapidly changing markets.</p>
                        <p>With LocalScale, you can enhance your visibility and connect with potential buyers and sellers in the neighborhoods and zip codes that matter most.</p>
                        <p>Whether you specialize in luxury properties, first-time homebuyers, or investment opportunities, our precision-targeted ad network enables you to reach individuals actively looking to buy or sell their homes.</p>
                        <p>By leveraging LocalScale, you can ensure that your listings get the attention they deserve, driving more leads and sales for your business. Let us help you stay ahead of the competition and maximize your success in the real estate market.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-real-estate.png" alt="Real Estate">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote"> “LocalScale has been a game-changer for my real estate business. Their targeted advertising solutions have allowed me to effectively showcase my listings and connect with motivated buyers and sellers in specific zip codes. Thanks to LocalScale, I've been able to stand out in the competitive market and close more deals.”</h3>
                    <p class="testimonial-customer">– John Reynolds, Realtor at Cityscape Realty</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
